import * as React from "react";
import {
  createBrowserRouter,
} from "react-router-dom";

 /*** 引入路由组件 ***/  
 import Error404 from "./Error404.js";
 import Home from "../Home.js";
 import Service from '../Service.js';
 import Solution from '../Solution.js';
 import Case from '../Case.js';
 import Aboutus from '../Aboutus.js';
 import New from '../New.js';
 import Contact from '../Contacts.js';
  /*** 引入路由组件 ***/ 

 const BasicRouter = createBrowserRouter([
	{
		path: "/",
		element: <Home m='home' />,
		errorElement: <Error404/>,
	},{
		path: "/home",
		element: <Home m='home' />,
		errorElement: <Error404/>,
	},{
		path: "/services",
		element: <Service m='services'/>,
	},{
		path: "/solutions",
		element: <Solution m='solutions'/>,
	},{
		path: "/cases",
		element: <Case m='cases'/>,
	},{
		path: "/aboutus",
		element: <Aboutus m='aboutus'/>,
	},{
		path: "/news",
		element: <New m='news'/>,
	},{
		path: "/contacts",
		element: <Contact m='contacts'/>,
	},
]);

export default BasicRouter